"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var PurchasePriceRow_1 = require("../model/PurchasePriceRow");

var PurchasePriceRowConverter_1 = require("./PurchasePriceRowConverter");
/**
 * Implementation of {@link PurchasePriceRowConverter}
 *
 * @author RV
 */


var PurchasePriceRowConverterImpl =
/*#__PURE__*/
function (_PurchasePriceRowConv) {
  _inherits(PurchasePriceRowConverterImpl, _PurchasePriceRowConv);

  function PurchasePriceRowConverterImpl() {
    _classCallCheck(this, PurchasePriceRowConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PurchasePriceRowConverterImpl).apply(this, arguments));
  }

  _createClass(PurchasePriceRowConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PurchasePriceRow_1.PurchasePriceRow(PurchasePriceRow_1.PurchasePriceRow.schema.id.valueOf(conversions.documentToClassId(source)), PurchasePriceRow_1.PurchasePriceRow.schema.externalId.valueOfField(source), PurchasePriceRow_1.PurchasePriceRow.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), PurchasePriceRow_1.PurchasePriceRow.schema.groupOfSiteId.valueOf(conversions.toClassReferenceId(source.groupOfSiteId)), PurchasePriceRow_1.PurchasePriceRow.schema.amount.valueOf(conversions.toBigNumber(source.amount)), PurchasePriceRow_1.PurchasePriceRow.schema.amountNett.valueOf(conversions.toBigNumber(source.amountNett)), PurchasePriceRow_1.PurchasePriceRow.schema.vatId.valueOf(conversions.toClassReferenceId(source.vatId)), PurchasePriceRow_1.PurchasePriceRow.schema.supplierId.valueOf(conversions.toClassReferenceId(source.supplierId)), PurchasePriceRow_1.PurchasePriceRow.schema.validFrom.valueOfField(source), PurchasePriceRow_1.PurchasePriceRow.schema.validTo.valueOfField(source), PurchasePriceRow_1.PurchasePriceRow.schema.promotionId.valueOf(conversions.toClassReferenceId(source.promotionId)), conversions.asFlagSet(source.stateFlags, EntityStateFlag_1.EntityStateFlag), PurchasePriceRow_1.PurchasePriceRow.schema.processed.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        productId: conversions.toDocumentReferenceId(source.productId),
        groupOfSiteId: conversions.toDocumentReferenceId(source.groupOfSiteId),
        amount: conversions.fromBigNumber(source.amount),
        amountNett: conversions.fromBigNumber(source.amountNett),
        vatId: conversions.toDocumentReferenceId(source.vatId),
        supplierId: conversions.toDocumentReferenceId(source.supplierId),
        validFrom: conversions.fromDate(source.validFrom),
        validTo: source.validTo ? conversions.fromDate(source.validTo) : null,
        promotionId: conversions.toDocumentReferenceId(source.promotionId),
        stateFlags: source.stateFlags.serialize(),
        processed: source.processed
      });
      return result;
    }
  }]);

  return PurchasePriceRowConverterImpl;
}(PurchasePriceRowConverter_1.PurchasePriceRowConverter);

exports.PurchasePriceRowConverterImpl = PurchasePriceRowConverterImpl;